import axios from '@/axios'

const getHttpStatus = (err) => {
  if (!err || !err.response) return null
  if (err.response.status) return err.response.status
  if (err.response.data && err.response.data.status) return err.response.data.status
  return null
}

export const getMessageFromError = (err) => {
  const status = getHttpStatus(err)

  if (status === 426) {
    delete axios.defaults.headers.common['Authorization']
    const url = `${process.env.VUE_APP_API_END_POINT}auth/refresh-token`
    const refresh_token = localStorage.getItem('refreshToken')

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${refresh_token}`
      }
    }

    return axios
      .post(url, {}, config)
      .then((response) => {
        const data = response.data.data
        if (response.status === 200) {
          localStorage.setItem('accessToken', data.access_token)
          localStorage.setItem('refreshToken', data.refresh_token)
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`

          const originalRequestConfig = err.config
          originalRequestConfig.headers['Authorization'] = `Bearer ${data.access_token}`
          return axios(originalRequestConfig)
        }
        return Promise.reject(err)
      })
      .catch((error) => {
        console.error('Error refreshing token:', error)
        return Promise.reject(error)
      })
  }

  const message =
    err.response && err.response.data && err.response.data.errors
      ? err.response.data.errors[0].msg
      : err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : err.message
  return { message }
}

export const handleFormError = (err) => {
  if (err.response.data && err.response.data.errors) {
    const messages = err.response.data.errors.reduce((acc, item) => {
      acc[item.param] = item.msg
      return acc
    }, {})
    return messages
  }
}

export const debounce = (fn, wait) => {
  let throttled = false
  return function (...args) {
    if (!throttled) {
      fn.apply(this, args)
      throttled = true
      setTimeout(() => {
        throttled = false
      }, wait)
    }
  }
}
